import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/admin/category-report`;

// trackingList: pasted string (one tracking per line) or array of strings.
const generateCategoryReport = async (trackingList) => {
    return await axios.post(API_URL, { trackingList });
};

// Enrich titles + categorize a pasted batch on demand (so items drop out of review).
const prepareBatch = async (trackingList) => {
    return await axios.post(`${BACKEND_URL}/api/admin/category-prepare-batch`, { trackingList });
};

// Tier-2 review: get a claude.ai prompt for the flagged items.
const getReviewPacket = async (trackingList) => {
    return await axios.post(`${BACKEND_URL}/api/admin/category-review-packet`, { trackingList });
};

// Import the pasted claude.ai results. assignments: [{ tracking, category }]
const importReview = async (assignments) => {
    return await axios.post(`${BACKEND_URL}/api/admin/category-review-import`, { assignments });
};

const CategoryReportService = {
    generateCategoryReport,
    prepareBatch,
    getReviewPacket,
    importReview,
};

export default CategoryReportService;
